import { Injectable } from '@angular/core';
import { StatusGraphNode } from '@models';
import { Store } from '@ngrx/store';
import { AppState } from 'app/@store/app.state';
import { statusGraphActions, statusGraphSelectors } from 'app/@store/stores';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatusGraphFacade {
  constructor(private _store: Store<AppState>) {
    this.statusGraph$ = _store.select(statusGraphSelectors.selectStatusGraph);
    this.loading$ = _store.select(statusGraphSelectors.selectLoading);
  }

  public statusGraph$: Observable<StatusGraphNode[]>;
  public loading$: Observable<boolean>;

  fetchStatusGraph(): void {
    this._store.dispatch(statusGraphActions.fetchStatusGraph());
  }

  save(statusGraph: StatusGraphNode[]): void {
    this._store.dispatch(statusGraphActions.saveStatusGraph({ statusGraph }));
  }
}
